var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('identify-confirm',{attrs:{"top-page-id":"mb038","previous-page-id":"mb035","next-page-id":"mb037"}},[_c('template',{slot:"wizard"},[_c('main-wizard',{attrs:{"active-index":2,"type":"useridentity"}})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b72af74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Mb036.vue
// module id = null
// module chunks = 